<div class="titlebar">
  <h3>
    {{ "Template.SupplierProductDetailComponent.subHeader_supplierProduct" | translate }}
  </h3>

  <div class="buttons">
    <button class="btn btn-secondary" [disabled]="loading" (click)="reload()">
      <fa-icon icon="arrow-rotate-right"></fa-icon>
    </button>
  </div>
</div>

@if (loading) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (supplierProduct) {
  <div>
    <div class="tab-pane fade show" id="details" role="tabpanel">
      <h5 class="mb-2">{{ "Template.SupplierProductDetailComponent.subHeader_details" | translate }}</h5>
      <div class="row">
        <div class="col-6 content">
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_id" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.id) {
                <span>{{ supplierProduct.id }}</span>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_description" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.description) {
                <span>{{ supplierProduct.description }}</span>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_supplierArticleNo" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.supplierProductId) {
                <span>{{ supplierProduct.supplierProductId }}</span>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_supplier" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.supplierPartyId) {
                <span>{{ supplierProduct.supplierPartyId }}</span>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_furtherIds" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.identifications) {
                <ul>
                  @for (sp of supplierProduct.identifications; track sp) {
                    <li>
                      @if (sp.type && sp.value) {
                        <span>{{ sp.type }}: {{ sp.value }}</span>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_linkedProducts" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.links) {
                <ul>
                  @for (link of supplierProduct.links; track link) {
                    <li>
                      @if (link.type && link.supplierProductId) {
                        <span>{{ link.type }}: {{ link.supplierProductId }}</span>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_prices" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.prices) {
                <ul>
                  @for (price of supplierProduct.prices; track price) {
                    <li>
                      @if (price.type && price.value) {
                        <span>{{ "Template.SupplierProductDetailComponent.text_" + price.type | translate }}: {{ price.value }}</span>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_createdDate" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.createdDate) {
                <span>{{ supplierProduct.createdDate | date : "d. MMMM yyyy, h:mm a z" }}</span>
              }
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_lastModifiedDate" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (supplierProduct.lastUpdatedDate) {
                <span>{{ supplierProduct.lastUpdatedDate | date : "d. MMMM yyyy, h:mm a z" }}</span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <strong>{{ "Template.SupplierProductDetailComponent.label_documents" | translate }}</strong>
            </div>
            <div class="col-6">
              @if (documentUrls) {
                <ul>
                  @for (documentUrl of documentUrls | keyvalue; track documentUrl) {
                    <li>
                      <a [href]="documentUrl.key" target="_blank">{{ documentUrl.value }}</a>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <strong>{{ "Template.SupplierProductDetailComponent.label_attributes" | translate }}</strong>
            </div>
          </div>
          <div id="attributesList" class="row">
            <div class="col-12">
              @if (supplierProduct.attributes) {
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col" class="col-md-2 col-sm-1">
                        {{ "Template.SupplierProductDetailComponent.label_key" | translate }}
                      </th>
                      <th scope="col" class="col-md-2 col-sm-1">
                        {{ "Template.SupplierProductDetailComponent.label_value" | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (attribute of supplierProduct.attributes | keyvalue; track attribute) {
                      <tr>
                        <td>{{ attribute.key }}</td>
                        <td>{{ attribute.value }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
        <div class="col-6">
          @for (imageUrl of imageUrls | keyvalue; track imageUrl) {
            <div class="row">
              <img [src]="imageUrl.key" />
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
